//SOURCE: https://www.notion.so/seriousmd/Known-ProgramIDs-for-Partners-Programs-89737fdae6c744fdb9c4813c30c09b31


// Sanofi | Try-It
export const isTryItProgramId = (programid) => {
          /// from beta
          ////// Test 4 - Sanofi Try-It Program (Toujeo Custom Approval)
  return programid === '60ace280561db2b10b21a08d' ||
          ////// Test 3 - Sanofi Try-It Program (Toujeo & Soliqua)
          programid === '60938ea1262675b262cd0c0f' ||
          ////// Sanofi Try-It Program - Diabetes
          programid === '608fad35790638e6ad9e6f60' ||
          /// from prod
          ////// Testing 2 - Sanofi Try-It Program (Toujeo & Soliqua)
          programid === '609004f2a5646b474e901e10' ||
          ////// Testing Sanofi Try-It Program (Toujeo & Soliqua)
          programid === '608906f5696413d8cec9147f' ||
          ////// Sanofi Try-It Program - Diabetes
          programid === '608fdce62556530ef62a81a8' ||
          ////// Sanofi Try-It Program - Cardio Thrombo
          programid === '611135e9556efedde2720f86';
};

// Novo Nordisk | Saxenda | WeighNow
export const isSaxendaProgramId = (programid) => {
  return programid === '646e1989f12476befeccb52f' ||
         programid === '64119104f4715eb4059522ae';
};

// Abbott | FreeStyle Libre Experience
export const isFSLEProgramId = (programid) => [
  '64955dffa01dccef1b315d33', // staging
  '64d0ec480a6df35598e72c69', // prod
].includes(programid);

// COUPON IMAGE
export const SaxendaWeighNowImage = 'https://static.seriousmd.com/programs/novonordisk-saxenda-pen.png';
export const FSLEImage = 'https://static.seriousmd.com/programs/freestyle-libre-program-invite-thumb.png';
export const TryItImage = 'https://static.seriousmd.com/medkit/medicine/sanofi-toujeo-300units-1.png';

export const getCouponLogo = (coupon) => {
        if (!coupon) return null;

	if (coupon.couponimageurl) {
		return coupon.couponimageurl;
	} else if (coupon.programid) {
		if (isSaxendaProgramId(coupon.programid)) return SaxendaWeighNowImage;
		if (isFSLEProgramId(coupon.programid)) return FSLEImage;
		if (isTryItProgramId(coupon.programid)) return TryItImage;
	}

	return null;
}
